import React from 'react';
import styles from './ProgressIndicator.module.css';

interface ProgressStep {
  id: string;
  title: string;
  description?: string;
  completed: boolean;
  current: boolean;
}

interface ProgressIndicatorProps {
  steps: ProgressStep[];
  currentStep: number;
  themeColor?: string;
}

const ProgressIndicator: React.FC<ProgressIndicatorProps> = ({
  steps,
  currentStep,
  themeColor = '#3B82F6'
}) => {
  // Calculate progress percentage
  const progressPercentage = (currentStep / (steps.length - 1)) * 100;
  
  return (
    <div className={styles.container}>
      <div className={styles.progressBar}>
        <div
          className={styles.progressFill}
          style={{
            width: `${progressPercentage}%`,
            background: `linear-gradient(90deg, ${themeColor}, #8b5cf6)`
          }}
        />
      </div>
      
      <div className={styles.steps}>
        {steps.map((step, index) => (
          <div
            key={step.id}
            className={`${styles.step} ${
              step.completed ? styles.completed : ''
            } ${step.current ? styles.current : ''}`}
          >
            <div className={styles.stepCircle}>
              {step.completed && !step.current ? (
                <i className="fas fa-check"></i>
              ) : (
                index + 1
              )}
            </div>
            <div className={styles.stepContent}>
              <h3 className={styles.stepTitle}>{step.title}</h3>
              {step.description && (
                <p className={styles.stepDescription}>{step.description}</p>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ProgressIndicator;
